export default __webpack_public_path__ + "static/media/P400_F_BD.56764099.pdf";